
export const WireGradeData=[
  {
  id:1,
  grade:"SS Wire",
  link:'/SSWire',                           

},
{
  id:2,

  grade:"Inconel Wire",
  link:'/InconelWire',

},
{
  id:3,
 
  grade:"Monel Wire",
  link:'/MonelWire',

  
},
{
  id:4,

  grade:"NICKEL Wire",
  link:'/NickelWire',

  
},
{
  id:6,
  grade:"TITANIUM Wire",
  link:'/titaniumCWire',
  
},
{
  id:9,

  grade:"SMO 254 Wire",
  link:'/SMO254Wire',
},
{
  id:10,
 
  grade:"Hastelloy Wire",
  link:'/HastelloyWire',

  
},
{
  id:5,
  grade:"Alloy 20 Wire",
  link:'/Alloy20Wire',
 
},
{
  id:12,
  grade:"Duplex Superduplex Wire",
  link:'/DuplexSuperduplexWire',
  
  
},
]

export const SSWireData = [
  {
    text1:
      "Stainless Steel Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Stainless Steel Wire, which keeps up exceptional usage check in applications where the temperature is between the degree of Degree F and Degree F. Regardless, acids and dangerous blueprints containing halide particles can be especially solid, and the use obstacle of our Stainless Steel Filler Wire may conceivably be lacking",
    text3:
      "Oxidation opposition of this Stainless Steel Electrode is high for consistent assistance of Degree F, unusual to Degree F. Constantly in different thing shapes, the grain size and carbon substance can meet customers' fundamentals, where watery crumbling limitation resembles our Stainless Steel Welding Wire. Warmth treatment as per this Stainless Steel Welding Electrode requires an answer toughen at Degree F, and some time later air cool, further age at Degree F for 16 hours and after that air cool.",
    Specifications: {
      Specifications: "ASTM A580 ASME SA580 / ASTM A313 ASME SA313",
      Dimensions: "STM, ASME",
      Size: "2.5mm – 9.00mm",
      Grades:
        "201, 201cu, 302, 302 HQ, 304HC 304L, 304H, 316L, 316Ti, 420,430L",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize:
        "Wire, Filler Wire, Coil Wire, Electrode, Welding Electrode, Welding Wire",
    },
    chemical: {},
  },
];
export const InconelWireData = [
  {
    text1:
      "Inconel Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Inconel Coil Wire, Inconel Alloy Wire, Inconel Wire, ASTM B166 Inconel Wire, Inconel Wire Suppliers And Exporters In Mumbai, India. Exporters Of ASTM SB166 Inconel Wire, Inconel Bright Wire, Inconel Wire Manufacturer In India. ASME SB166 Inconel Wire,Inconel Alloy Wire Exporter, Inconel Wire Bobbin, Inconel Alloy Wire Rope Manufacturer In India. Tig Wire Welding, Mig Wire Welding, Tig Welding Spool, Mig Welding Spool.",
    text3:
      "Inconel Coil Wires are potentially improved use obstruction over different amalgams of treated steel in unequivocally oxidizing conditions because of the expansion of columbium (niobium) and tantalum. The best checks for in general piece of the general business for Inconel Coil Wires are between 1 % and 3 %. At moderate temperatures and fixations, Inconel Wires is a legitimate decision rather than unadulterated nickel, which might be struck by weakening usage. Moreover, Inconel Electrode in like way contains extra segments of titanium and aluminum. The nickel substance of Inconel Electrode moreover contributes general usage, affirmation from scaling and stress – crumbling breaking. Blend Wire is grasped for association up to 600 Degree F, where likewise, gathering point is 2615 Degree F – 2635 Degree F. Quality and hardness of Alloy Wires increment with essentially slight deficiency of flexibility or effect square.",
    Specifications: {
      Specifications: "ASTM B166 ASME SB166",
      Dimensions: "ANSI/AWCI – 01 -1992 and ASTM E 2016-11 and RRW 360",
      Size: "2.5mm – 9.00mm",
      Grades: "Inconel 600,625,800,825,925",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize: "Filler Wire, Coil Wire",
    },
    chemical: {},
  },
];
export const MonelWireData = [
  {
    text1:
      "Monel Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Monel Coil Wire, Monel Alloy Wire, Monel Wire, ASTM B164 Monel Wire Suppliers And Exporters In Mumbai, India. Monel Bright Wire, Monel Wire, Exporters Of ASTM SB164 Monel Wire Manufacturer In India. Monel Wire Bobbin, Monel Alloy Wire Rope, Monel Alloy Exporter, ASME SB164 Monel Wire, Manufacturer In India. Tig Wire Welding, Mig Wire Welding, Tig Welding Spool, Mig Welding Spool.",
    text3:
      "Composites, including this Monel Alloy , are exceedingly looked for after in light of their capacity to tie both oxidization and carbonization in high – temperature settings. In like manner as other of the blends in the Incoloy family, our Monel Alloy Coil Wire offers clients express central center interests.",
    Specifications: {
      Specifications: "ASTM B164 ASME SB164",
      Length: "100 mm TO 6000 mm",
      Diameter: "0.01 mm To 200 mm",
      Dimensions: "ANSI/AWCI – 01 -1992 and ASTM E 2016-11 and RRW 360",
      Size: "2.5mm – 9.00mm",
      Grades: "MONEL 400 ,MONEL K500",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize: "Filler Wire, Coil Wire, Electrode Wire, Welding Wire.",
    },
    chemical: {},
  },
];

export const NickelWireData = [
  {
    text1:
      "Nickel Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Nickel Wire, Nickel Coil Wire, Nickel Alloy Wire, Nickel Wire, ASTM B160 Nickel Wire Suppliers And Exporters In Mumbai, India. Nickel Wire, Nickel Bright Wire, Exporters Of ASTM SB160 Nickel Wire Manufacturer In India, Nickel Alloy Exporter, Nickel Wire Bobbin, Nickel Alloy Wire Rope, ASME SB160 Nickel Wire, Manufacturer In India. Tig Wire Welding, Mig Wire Welding, Tig Welding Spool, Mig Welding Spool.",
    text3:
      "The to some degree truly over the top rate motivation driving Nickel Coil Wire is especially kept up, paying little regard to all the burden in areas with high chloride introduction, especially the coast and vivaciously salted roadways. Normally, the customary detainments of both, Ni 200 Wire and Ni Wire, are joined into one and twofold ensured science achieving a single composite with the perfect characteristics of the two amalgams. Nickel Wire has stunning request from exhausting salts to and including the fluid state. In ruinous, dissolvable and reasonable salt methodologies Nickel displays stunning square, regardless in oxidizing salt plans stupid strike will occur. Our Nickel gives breathtaking relationship in spilling sea water even at enthusiastic, yet in moderate or amazingly low – speed sea water veritable neighborhood strike may occur under fouling living creatures or various stores.",
    Specifications: {
      Specifications: "ASTM B160 ASME SB160",
      Length: "100 mm TO 6000 mm",
      Diameter: "0.01 mm To 200 mm",
      Dimensions: "ANSI/AWCI – 01 -1992 and ASTM E 2016-11 and RRW 360",
      Size: "2.5mm – 9.00mm",
      Grades: "Nickel 200,Nickel 201",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize: "Filler Wire, Coil Wire",
    },
    chemical: {},
  },
];
export const TitaniumWireData = [
  {
    text1:
      "Titanium Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Titanium Coil Wire, Titanium Wire, Ti. Alloy Wire, Alloy Wire, Titanium Wire Suppliers And Exporters In Mumbai, India, Titanium Bright Wire, Titanium Alloy Wire, Exporters Of Titanium Wire Manufacturer In India. Tig Wire Welding, Mig Wire Welding, Tig Welding Spool, Mig Welding Spool.",
    text3:
      "Titanium is utilized if all else fails in applications that require welding in setting on its solid weldability properties. Ti Wire is higher in quality than CP , at any rate lower in quality than CP and CP . Ti is utilized in flight, air transportation, military, mix, petrochemical industry, in the helpful field, profitable stones, approach of estimation instruments, striking purposes. Titanium wire is what's relentlessly utilized in Architecture, Automotive Desalination, Dimensional Stable Anodes, Medical, Marine, and Processing and Chlorate Suppliers. As a solitary – sort out material, the properties of Ti Welding Wire are obliged by science (iron and interstitial dirtying effect parts) and grain measure.",
    Specifications: {
      Specifications: "ASTM B863 ASME SB863",
      Length: "100 mm TO 6000 mm",
      Diameter: "0.01 mm To 200 mm",
      Dimensions: "ANSI/AWCI – 01 -1992 and ASTM E 2016-11 and RRW 360",
      Size: "2.5mm – 9.00mm",
      Grades: "Titanium Grade 2,Titanium Grade 5",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize: "Filler Wire, Coil Wire",
    },
    chemical: {},
  },
];
export const SMO254WireData = [
  {
    text1:
      "SMO 254 Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "254 SMO Steel Coil Wire, 6Moly Wire, 254 SMO Filler Wire, ASTM A580 SMO Wire, SMO 254 Welding Suppliers And Exporters In Mumbai,India. SMO UNS S31254 Bright Wire, Exporters Of ASTM SA580 254 SMO Wire, Alloy 254 Wire, SMO WERKSTOFF NR. 1.4547 Wire Manufacturer In India. Tig Wire Welding, Mig Wire Welding, Tig Welding Spool, Mig Welding Spool.",
    text3:
      "The strain level figures to a substituting worry for this Alloy 254 Wire, where Rotary flexure testing systems have been settled. Our Alloy 254 other than reports that purposeful field information for channeling frameworks endorse that if the structure props up past 10 million cycles, it will have unending life.",
    Specifications: {
      Specifications: "ASTM A580 ASME SA580 / ASTM A313 ASME SA313",
      Length: "MAX 12000 mm",
      Diameter: "0.01 mm To 200 mm",
      Dimensions: "ASTM, ASME",
      Size: "2.5mm – 9.00mm",
      Grades: "Nickel 200,Nickel 201",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize:
        "Wire, Filler Wire, Coil Wire, Electrode, Welding Electrode, Welding Wire",
    },
    chemical: {},
  },
];
export const HastelloyWireData = [
  {
    text1:
      "Hastelloy Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Hastelloy Alloy Wire, Hastelloy Wire, ASTM B574 Hastelloy Wire, Hastelloy Coil Wire, Hastelloy Wire Suppliers And Exporters In Mumbai, India. Hastelloy Bright Wire, Exporters Of ASTM SB574 Hastelloy Wire, Hastelloy Wire Manufacturer In India. ASME SB574 Hastelloy Wire, Hastelloy Wire Bobbin, Hastelloy Alloy Wire Rope, Hastelloy Alloy Wire Exporter, Manufacturer In India. Tig Wire Welding, Mig Wire Welding, Tig Welding Spool, Mig Welding Spool.",
    text3:
      "Hastelloy Alloy Wire where a run of the mill high – speed steel drill can be used to achieve the perfect summit when drilling these composites. We in like manner offer these things in different assessments, for instance, Hastelloy Wire, Hastelloy B2 Wire, Hastelloy B3 Wire and Hastelloy X Wire. Hastelloy Wire is a vastly significant – building up evaluation and is used where to some degree ideal grouch quality and block over setting and stress – decay breaking are required despite the general properties of the 12 % chromium treated steels. Modi Metals is one of the well – known stockiest and supplier for Hastelloy Coil Wire, where we have been established on improvements in composite metallurgy, in relaxing headway and in thermo – mechanical overseeing.",
    Specifications: {
      Specifications: "ASTM B574 ASME SB574",
      Length: "100 mm TO 6000 mm",
      Diameter: "0.01 mm To 200 mm",
      Dimensions: "ANSI/AWCI – 01 -1992 and ASTM E 2016-11 and RRW 360",
      Size: "2.5mm – 9.00mm",
      Grades: "HastelloyC22,HastelloyC276,HastelloyX",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize:
        "Wire, Filler Wire, Coil Wire, Electrode, Welding Electrode, Welding Wire",
    },
    chemical: {},
  },
];
export const Alloy20WireData = [
  {
    text1:
      "Alloy 20 Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Alloy 20 Wire, Alloy 20 Coil Wire, 20Cb-3® Filler Wire, ASTM B473 Alloy 20 Wire Suppliers And Exporters In Mumbai, India. Alloy WERKSTOFF NR. 2.4660 Wire, Alloy UNS N08020 Bright Wire, Exporters Of ASTM SB473 Alloy 20 Wire Manufacturer In India. Alloy 20 Exporter, Alloy 20 Wire Bobbin, Alloy 20 Wire Rope, ASME SB473 20Cb-3® Wire, Manufacturer In India.Tig Wire Welding, Mig Wire Welding, Tig Welding Spool, Mig Welding Spool",
    text3:
      "The Modi Metals. is one of the well – known stockiest and supplier for Alloy 20 Coil Wire, where we have been established on improvements in composite metallurgy, in relaxing headway and in thermo – mechanical overseeing. During method formation of Alloy 20 Wire, it is vital to consider the length of the unsupported piece of the drill, and it shouldn't be any more stretched out than the required length expected to enter the criticalness of the opening, engaging the chips to stream out the hole reasonably without hurting or breaking the drill. To resuscitate the course toward walloping Alloy 20 Wire a perfect mix of squashing fluid, beating plan speeds should be used.",
    Specifications: {
      Specifications: "ASTM B473 ASME SB473",
      Length: "100 mm TO 6000 mm",
      Diameter: "0.01 mm To 200 mm",
      Dimensions: "ANSI/AWCI – 01 -1992 and ASTM E 2016-11 and RRW 360",
      Size: "2.5mm – 9.00mm",
      Grades: "Alloy 20",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize:
        "Wire, Filler Wire, Coil Wire, Electrode, Welding Electrode, Welding Wire",
    },
    chemical: {},
  },
];
export const DuplexWireData = [
  {
    text1:
      "Duplex & Superduplex Wire Exporters,Suppliers,Importers,Stockists In Mumbai and India.",
    text2:
      "Duplex Steel Wire, Duplex Steel Coil Wire, Super Duplex Stainless Steel Wire, ASTM A276 Super Duplex Steel Wire, Duplex Steel Wire Suppliers And Exporters. Exporters Of ASTM SA276 Super Duplex Steel 2507 Wire, Duplex Steel Bright Wire, Duplex Steel Wire Manufacturer In India. Super Duplex Steel Wire Rope, ASME SA276 Ferritic / Austenitic Duplex Steel 2205 Wire, Duplex Steel Wire Bobbin, Super Duplex Stainless Steel 2507 Wire Exporter, Manufacturer In India. Tig Wire Welding, Mig Wire Welding, Tig Welding Spool, Mig Welding Spool.",
    text3:
      "As exhibited by our Super Duplex Steel Welding Wire, a challenged person sodium chloride course of action is all around mentioned gushed onto an electrically warmed model, which is then appeared tractable weight. The related worries in this Duplex Steel Coiled Wire are very much arranged reached out in growthes of 20 % until they are 90 % of the material's yield quality at 392 Degree F. The Modi Metals is one of the well – saw exchanging house and provider of our Super Duplex Steel Wire which has a coefficient of warm improvement near that of carbon steel.",
    Specifications: {
      Specifications: "ASTM A276 ASME SA276",
      Diameter: "100 mm To 6000 mm",
      Dimensions: "ASTM, ASME",
      Size: "2.5mm – 9.00mm",
      Grades: "Duplex and Super Duplex",
      Finish:
        "Bright Drawn, Bright shiny, Matt Drawn, Coated, De-coated, Soap Drawn ( Skin Pass )",
      Temper: "Soft, 1/8 hard, ¼ hard, ½ hard, ¾ hard, full hard",
      Tolerance: "As per ASTM and EN Standard",
      Packing:
        "Coils of 250- 500 kgs, Coils are wrapped in Plastic film Or HDPE",
      Specialize:
        "Wire, Filler Wire, Coil Wire, Electrode, Welding Electrode, Welding Wire",
    },
    chemical: {},
  },
];
